import type { Requests } from "../common/request.common";
import type { AuditProductInternetResponseTypes } from "../common/response.common";
import { get, post, postEmpty } from "./common";

export const auditProductInternet = {
    record(data: typeof Requests.AuditProductInternet.Record.Input) {
        return post<typeof data, AuditProductInternetResponseTypes.Record>(
            `/audit-product-internet/record`,
            data,
        );
    },
    obtain(id: string) {
        return get<AuditProductInternetResponseTypes.Obtain>(
            `/audit-product-internet/obtain/${id}`,
        );
    },
    selectRecord(data: typeof Requests.AuditProductInternet.SelectRecord.Input) {
        return post<typeof data, AuditProductInternetResponseTypes.SelectRecord>(
            `/audit-product-internet/select-record`,
            data,
        );
    },
    selectToggle(id: string) {
        return postEmpty<AuditProductInternetResponseTypes.SelectToggle>(
            `/audit-product-internet/select-toggle/${id}`,
        );
    },
};
